import { render, staticRenderFns } from "./RenovacionAutomaticaCard.vue?vue&type=template&id=4e20a6dc"
import script from "./RenovacionAutomaticaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RenovacionAutomaticaCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports